import { submitFeatureRequest } from '../../../src/services/featureRequests';
import { FEATURE_REQUEST_MAX_LENGTH } from '../../../src/services/featureRequestRules';

/**
 * `feedback.ts`'nin web karşılığı. Masaüstü geri bildirimi uygulama veri
 * klasörüne yazıyor; tarayıcıda öyle bir yer yok. Ekibin okuyabildiği tek
 * kanal yönetim konsolundaki Geri bildirim listesi (özellik istekleriyle aynı tablo).
 */
export async function saveFeedback(text: unknown, _email: unknown): Promise<void> {
  const body = typeof text === 'string' ? text.trim().slice(0, FEATURE_REQUEST_MAX_LENGTH) : '';
  if (!body) return;
  await submitFeatureRequest(body);
}
